import {
    DXP_GET_ALL_301_REDIRECTS,
    DXP_GET_301_REDIRECTS_PAGINATED,
    DXP_GET_301_REDIRECTS_PAGINATED_ERROR,
    DXP_GET_301_REDIRECTS_COUNT,
    DXP_GET_301_REDIRECTS_COUNT_ERROR,
    DXP_ALL_301_REDIRECTS_ERROR,
    DXP_ADD_301_REDIRECTS_BULK,
    DXP_ADD_301_REDIRECTS_BULK_ERROR,
    DXP_ADD_301_REDIRECT,
    DXP_ADD_301_REDIRECT_ERROR,
    DXP_ADD_404_TO_301,
    DXP_ADD_404_TO_301_ERROR,
    DXP_GET_404_PAGES_PAGINATED,
    DXP_GET_404_PAGES_PAGINATED_ERROR,
    DXP_SELECT_404_PAGE,
    DXP_GET_404_PAGE_COUNT,
    DXP_GET_404_PAGE_COUNT_ERROR,
    DXP_SET_404_LOADING
} from "../actions/types";

const initialState = {
    count: null,
    pages404: [],
    pages301: [],
    selected404Page: null,
    paginated301Redirects: [],
    count301: null,
    is404Loading: true,
    isLoading: true,
    success: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case DXP_GET_ALL_301_REDIRECTS:
            return {
                ...state,
                pages301: payload,
                isLoading: false,
                success: true,
            };
        case DXP_GET_301_REDIRECTS_PAGINATED:
            return {
                ...state,
                paginated301Redirects: payload,
                isLoading: false,
                success: true,
            };
        case DXP_GET_301_REDIRECTS_COUNT:
            return {
                ...state,
                count301: payload,
                isLoading: false,
                success: true,
            };
        case DXP_GET_404_PAGES_PAGINATED:
            return {
                ...state,
                pages404: payload,
                is404Loading: false,
                success: true,
            };

        case DXP_GET_404_PAGE_COUNT:
            return {
                ...state,
                count: payload,
                success: true
            }

        case DXP_SELECT_404_PAGE:
            return {
                ...state,
                selected404Page: payload,
            };

        case DXP_SET_404_LOADING:
            return {
                ...state,
                is404Loading: payload,
            };
        case DXP_ADD_301_REDIRECTS_BULK:
        case DXP_ADD_301_REDIRECT:
            return {
                ...state,
                isLoading: false,
                success: true,
            };
        case DXP_ADD_301_REDIRECTS_BULK_ERROR:
        case DXP_ADD_301_REDIRECT_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
            };
        case DXP_ALL_301_REDIRECTS_ERROR:
            return {
                ...state,
                pages301: [],
                isLoading: false,
                success: false,
            };
        case DXP_GET_301_REDIRECTS_PAGINATED_ERROR:
            return {
                ...state,
                paginated301Redirects: [],
                isLoading: false,
                success: false,
            };
        case DXP_GET_301_REDIRECTS_COUNT_ERROR:
            return {
                ...state,
                count: null,
                isLoading: false,
                success: false,
            };
        case DXP_GET_404_PAGES_PAGINATED_ERROR:
            return {
                ...state,
                pages404: [],
                is404Loading: false,
                success: false,
            };

        case DXP_GET_404_PAGE_COUNT_ERROR:
            return {
                ...state,
                count: null,
                success: false
            }

        case DXP_ADD_404_TO_301:
            return {
                ...state,
                success: true,
            };
        case DXP_ADD_404_TO_301_ERROR:
            return {
                ...state,
                success: false,
            };
        default:
            return state;
    }
}

